<template>
    <CToaster class="toaster" :autohide="700">
        <template v-for="(toast,index) in content">
            <CToast
                :key="'toast-' + index"
                :show="true"
                :class="classColor(toast.color, toast.outline)"
                
            >
                <template #header>
                    <div>
                        <CIcon v-if="toast.color == 'success'" :content="$options.icons.cilCheckCircle"/> 
                        <CIcon v-else :content="$options.icons.cilWarning"/> 
                        <strong class="ml-2">{{$t(toast.header)}}</strong>
                    </div>
                    
                </template>
                {{ $t(toast.body) }}.
            </CToast>
        </template>
    </CToaster>
</template>

<script>
import { mapGetters } from "vuex";
import { cilCheckCircle, cilWarning } from '@coreui/icons';

export default {
    name: "InfoToastComponent",
    icons:{
        cilCheckCircle,
        cilWarning
    },
    computed:{
        ...mapGetters({
            fixedToasts:"toast/fixedToasts",
            content:"toast/content"
        }),
    },
    methods:{
        classColor(color, outline = false){

            let resp = (!outline)? `toast-${color}`:`toast-outline-${color}`;
            return resp;
        }
    },
    created(){
        this.$store.dispatch('toast/resetFixedToasts');
    }
}
</script>

<style lang="scss">
    .toaster{
        & .toast{
            flex-basis: auto;

            & .toast-header{
                justify-content: space-between;
                border-bottom: none;
                border-radius:0;
            }
        }

        

        & .toast.toast-success{
            
            border-left: 4px solid #23923d;
            background-color: #23923d29;
            & .toast-header{
                justify-content: space-between;
                background-color: #23923d29;
                border-bottom: none;
                border-radius:0;
                color: #23923d;
            }
            & .toast-body{
                background-color: #23923d29;
                color: #23923d;
            }
        }

        & .toast.toast-danger{
            
            border-left: 4px solid #bd2130;
            & .toast-header{
                justify-content: space-between;
                background-color: #ff8592;
                border-bottom: none;
                border-radius:0;
                color: #bd2130;
            }
            & .toast-body{
                background-color: #ff8592;
                color: #bd2130;
            }
        }

        height: auto;
        & .toast-outline-danger{
            border-color:rgba(255, 17, 0, 0.493);

            & .toast-header {
                @extend .toast-outline-danger;
                background-color: rgba(255, 17, 0, 0.5);
            }
            & .toast-body  {
                @extend .toast-outline-danger; 
            }
            
        }
        & .toast-outline-success{
            border-color:#2eb85c;

            & .toast-header {
                @extend .toast-outline-danger;
                background-color: #2eb85ca9;
            }
            & .toast-body  {
                @extend .toast-outline-danger; 
            }
            
        }
        
    }

</style>